/* eslint-disable no-restricted-syntax */
import { isWithinTimeFrame, parse } from 'helpers/dates';
import Big from 'big.js';
import NBXAccounts from 'services/accounts.service';

const transform = trade => {
  const [baseCurrency, quoteCurrency] = trade.market.split('-');
  const isBuy = trade.side === 'BUY';
  const fiatAmount = Big(trade.quantity).times(trade.price).toString();
  return {
    id: trade.orderId,
    created: parse(`${trade.createdAt}Z`),
    type: 'Trade',
    inAmount: isBuy ? trade.quantity : fiatAmount,
    inCurrency: isBuy ? baseCurrency : quoteCurrency,
    outAmount: isBuy ? fiatAmount : trade.quantity,
    outCurrency: isBuy ? quoteCurrency : baseCurrency,
    fee: trade.fee,
    feeCurrency: quoteCurrency,
    notes: trade.market,
    market: 'NBX',
    side: trade.side,
    price: trade.price,
    quantity: trade.quantity,
    isBuy,
    fiatAmount,
    quoteCurrency,
    baseCurrency
  };
};

const isTradeWithinTimeFrame = (greaterThan, lessThan) => trade =>
  isWithinTimeFrame(greaterThan, lessThan, trade.created);

export const fetchTrades = async (accountId, startTime, endTime) => {
  const trades = [];
  for await (const page of NBXAccounts.getTradesHistory(
    accountId,
    // since we cannot query api with timestamp accuracy, we need to query more data to filter out by user local time zone offset
    startTime && startTime.subtract(1, 'day'),
    endTime && endTime.add(1, 'day')
  )) {
    trades.push(...page.map(transform).filter(isTradeWithinTimeFrame(startTime, endTime)));
  }
  return trades;
};
